module.exports = __webpack_public_path__ + "static/media/MEPC-37980.e1e21a10.pdf";